<div *appIsDesktop>
  @if (invoiceHeaderResult) {
    <div id="invoiceHeader" class="header-container">
      <ds-divider></ds-divider>
      <!-- First Subsection -->
      <div id="firstSubSection" class="first-subSection">
        <div id="firstRow" class="header-row">
          <!-- Invoice To Name -->
          <div id="invoiceName">
            <typography variant="mat-caption-1" weight="regular" id="invoiceToNameLabel" class="info-label">{{ appStrings.invoice_toName }}</typography>
            <typography variant="mat-body-2" weight="bold" id="invoiceToNameValue">{{ invoiceHeaderResult.invoiceToName }}</typography>
          </div>
          <!-- Invoice To Address -->
          <div id="invoiceAddress">
            <typography variant="mat-caption-1" weight="regular" id="invoiceToAddressLabel" class="info-label">{{ appStrings.invoice_toAddress }}</typography>
            <typography variant="mat-body-2" weight="bold" id="invoiceToAddressValue">{{ invoiceHeaderResult.invoiceToAddress }}</typography>
          </div>
          <!-- Invoice To -->
          <div id="invoiceTo">
            <typography variant="mat-caption-1" weight="regular" id="invoiceToLabel" class="info-label">{{ appStrings.invoice_to }}</typography>
            <typography variant="mat-body-2" weight="bold" id="invoiceToValue">{{ invoiceHeaderResult.invoiceToBpNumber }}</typography>
          </div>
          <!-- Invoice Reference -->
          <div id="reference">
            <typography variant="mat-caption-1" weight="regular" id="invoiceReferenceLabel" class="info-label">{{ appStrings.invoice_reference }}</typography>
            <typography variant="mat-body-2" weight="bold" id="invoiceReferenceValue">{{ invoiceHeaderResult.firstReference || '-' }}</typography>
          </div>
        </div>
        <div id="secondRow" class="header-row">
          <!-- Sales Order Type -->
          <div id="invoiceOrderType">
            <typography variant="mat-caption-1" weight="regular" id="salesOrderTypeLabel" class="info-label">{{ appStrings.invoice_salesOrderType }}</typography>
            <typography variant="mat-body-2" weight="bold" id="salesOrderTypeValue">{{ invoiceHeaderResult.salesOrderType }}</typography>
          </div>
          <!-- PO Number -->
          <div id="poNumber">
            <typography variant="mat-caption-1" weight="regular" id="poNumberLabel" class="info-label">{{ appStrings.invoice_poNumber }}</typography>
            <typography variant="mat-body-2" weight="bold" id="poNumberValue">{{ invoiceHeaderResult.poNumber }}</typography>
          </div>
          <!-- Sales Representative -->
          <div id="salesRepresentative">
            <typography variant="mat-caption-1" weight="regular" id="salesRepLabel" class="info-label">{{ appStrings.invoice_salesRepresentative }}</typography>
            <typography variant="mat-body-2" weight="bold" id="salesRepValue">{{ invoiceHeaderResult.salesRepresentative }}</typography>
          </div>
          <!-- Sales Office -->
          <div id="salesOffice">
            <typography variant="mat-caption-1" weight="regular" id="salesOfficeLabel" class="info-label">{{ appStrings.invoice_salesOffice }}</typography>
            <typography variant="mat-body-2" weight="bold" id="salesOfficeValue">{{ invoiceHeaderResult.salesOffice }}</typography>
          </div>
        </div>
        <div id="thirdRow" class="header-row">
          <!-- Header Text -->
          <div id="headerText">
            <typography variant="mat-caption-1" weight="regular" id="headerTextLabel" class="info-label">{{ appStrings.invoice_headerText }}</typography>
            <typography variant="mat-body-2" weight="bold" id="headerTextValue">{{ invoiceHeaderResult.headerText || '-' }}</typography>
          </div>
          <div id="headerSpace_0">
            <typography class="info-label">&nbsp;</typography>
          </div>
          <div id="headerSpace_1">
            <typography class="info-label">&nbsp;</typography>
          </div>
          <div id="headerSpace_2">
            <typography class="info-label">&nbsp;</typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <!-- Second Subsection -->
      <div id="secondSubSection" class="second-subSection">
        <div id="firstRowSecondSub" class="header-row">
          <!-- Ship To Name -->
          <div id="shipToName">
            <typography variant="mat-caption-1" weight="regular" id="shipToNameLabel" class="info-label">{{ appStrings.invoice_shipToName }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToNameValue">{{ invoiceHeaderResult.shipToName }}</typography>
          </div>
          <!-- Ship To Address -->
          <div id="shipToAddress">
            <typography variant="mat-caption-1" weight="regular" id="shipToAddressLabel" class="info-label">{{ appStrings.invoice_shipToAddress }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToAddressValue">{{ invoiceHeaderResult.shipToAddress }}</typography>
          </div>
          <!-- Ship To -->
          <div id="shipTo">
            <typography variant="mat-caption-1" weight="regular" id="shipToLabel" class="info-label">{{ appStrings.invoice_shipTo }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToValue">{{ invoiceHeaderResult.shipTo }}</typography>
          </div>
          <!-- Invoice Date -->
          <div id="date">
            <typography variant="mat-caption-1" weight="regular" id="invoiceDateLabel" class="info-label">{{ appStrings.invoice_date }}</typography>
            <typography variant="mat-body-2" weight="bold" id="invoiceDateValue">{{ invoiceHeaderResult.invoiceDate | date: dateFormat }}</typography>
          </div>
        </div>
        <div id="secondRowSecondSub" class="header-row">
          <!-- Order Number -->
          <div id="orderNumber">
            <typography variant="mat-caption-1" weight="regular" id="orderNumberLabel" class="info-label">{{ appStrings.invoice_orderNumber }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderNumberValue">{{ invoiceHeaderResult.orderNumber }}</typography>
          </div>
          <!-- Order Date -->
          <div id="orderDate">
            <typography variant="mat-caption-1" weight="regular" id="orderDateLabel" class="info-label">{{ appStrings.invoice_OrderDate }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderDateValue">{{ invoiceHeaderResult.orderDate | date: dateFormat }}</typography>
          </div>
          <div id="headerSpace_3">
            <typography class="info-label">&nbsp;</typography>
          </div>
          <div id="headerSpace_4">
            <typography class="info-label">&nbsp;</typography>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<div *appIsMobile>
  @if (invoiceHeaderResult) {
    <div id="invoiceHeaderMobile" class="mobile header-container">
      <ds-divider></ds-divider>
      <div class="first-subSection">
        <!-- Invoice to Name -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_toName }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.invoiceToName }}</typography>
          </div>
        </div>
        <!-- Invoice to Address -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_toAddress }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.invoiceToAddress }}</typography>
          </div>
        </div>
        <!-- Invoice To -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_to }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.invoiceToBpNumber }}</typography>
          </div>
        </div>
        <!-- Invoice Reference -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_reference }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.firstReference || '-' }}</typography>
          </div>
        </div>
        <!-- PO Number and Sales Order Type -->
        <div class="header-row">
          <div class="mobile-field-half">
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_poNumber }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.poNumber }}</typography>
          </div>
          <div class="mobile-field-half">
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_salesOrderType }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.salesOrderType }}</typography>
          </div>
        </div>
        <!-- Sales Office and Sales Representative -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_salesOffice }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.salesOffice }}</typography>
          </div>
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_salesRepresentative }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.salesRepresentative }}</typography>
          </div>
        </div>
        <!-- Header Text -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_headerText }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.headerText || '-' }}</typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <!-- Shipping Information Section -->
      <div class="second-subSection">
        <!-- Ship to Name -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_shipToName }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.shipToName }}</typography>
          </div>
        </div>
        <!-- Ship to Address -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_shipToAddress }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.shipToAddress }}</typography>
          </div>
        </div>
        <!-- Ship To and Invoice Date -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_shipTo }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.shipTo }}</typography>
          </div>
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_date }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.invoiceDate | date: dateFormat }}</typography>
          </div>
        </div>
        <!-- Order Number and Order Date -->
        <div class="header-row">
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_orderNumber }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.orderNumber }}</typography>
          </div>
          <div>
            <typography variant="mat-caption-1" weight="regular" class="info-label">{{ appStrings.invoice_OrderDate }}</typography>
            <typography variant="mat-body-2" weight="bold">{{ invoiceHeaderResult.orderDate | date: dateFormat }}</typography>
          </div>
        </div>
      </div>
    </div>
  }
</div>